export enum TariffRateStatusTypeEnum {
	ACTIVE = "ACTIVE",
	UPCOMING = "UPCOMING",
	EXPIRED = "EXPIRED"
}
